import { api } from './config';
import type { MalwareResponse } from '../types/malware';

export async function searchMalware(fileHash: string): Promise<MalwareResponse> {
  try {
    console.log('Searching malware with hash:', fileHash);
    const response = await api.get<MalwareResponse>(`/api/search/malware/${encodeURIComponent(fileHash)}`);
    console.log('Malware API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching malware data:', error);
    console.log('Returning empty malware response');
    return { query_status: 'error', data: [] };
  }
}